import React from "react";
import styled from "styled-components";

const Privacy = () => {
  return (
    <>
    <div></div>
      <div className="container mt-5">
        <h1 className="mb-4 mt-5 text-center">Privacy Policy</h1>

        <div className="mt-5">
          <p className="text-secondary">        
            <br/>
            <h3 className="text-black">1. Introduction
            </h3>
            <p className="mt-2">BDA is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you engage with our services.</p>
            <br/>

            <h3 className="text-black">2. Information We Collect
            </h3>
            <p className="mt-2">We may collect the following types of personal information : </p>
            <li><b>Contact Information : </b> Name, email address, phone number, and mailing address.</li>
            <li><b>Project Information : </b> Details related to your projects, including specifications, plans, and design preferences.</li>
            <li><b>Financial Information : </b> Payment details, billing information, and any other necessary financial data.</li>
            <li><b>Communication Data : </b>  Any correspondence or communication between you and the Company.</li>
            <br/>

            <h3 className="text-black">3. How We Use Your Information
            </h3>
            <p className="mt-2">BDA may use your information for the following purposes : </p>
            <li> To provide and manage our architectural services.</li>
            <li> To communicate with you about your projects and respond to your inquiries.</li>
            <li> To process payments and manage billing.</li>
            <li> To improve our services and client experience.</li>
            <li> To comply with legal obligations and protect our rights.</li>
            <br/>

            <h3 className="text-black">4. Information Sharing
            </h3>
            <p className="mt-2">We do not sell, trade, or otherwise transfer your personal information to outside parties without your consent, except in the following circumstances : </p>
            <li><b>Service Providers : </b>We may share information with third-party service providers who assist us in delivering our services (e.g., payment processors, and project management tools) under strict confidentiality agreements.</li>
            <li><b>Legal Requirements : </b>We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
            <br/>

            <h3 className="text-black">5. Data Security
            </h3>
            <p className="mt-2">We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
            <br/>

            <h3 className="text-black">6. Your Rights
            </h3>
            <p className="mt-2">You have the right to : </p>
            <li> Access the personal information we hold about you.</li>
            <li> Request corrections to any inaccurate information.</li>
            <li> Request the deletion of your personal information, subject to legal obligations.</li>
            <li> Object to or restrict the processing of your personal information.</li>
            <p className="mt-2">To exercise these rights, Contact us using the information provided below.</p>
            <br/>
            <h3 className="text-black">7. Changes to This Privacy Policy
            </h3>
            <p className="mt-2">We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on our website with an updated effective date.</p>
          <br/>
          </p>
        </div>
      </div>
    </>
  );
};

export default Privacy;
const Container = styled.div``;
